import Sidebarlink from "./Sidebarlink.jsx";
import StatCard from "./Statcard.jsx";
import ShipmentTable from "./Shippmenttable.jsx";
import { useState } from "react";
import React from "react";
import { 
  Package, 
  ShoppingCart, 
  TrendingUp, 
  Truck, 
  Clock, 
  CheckCircle,
  AlertCircle,
  MoreHorizontal,
  Search,
  Bell,
  User,
  Menu,
  X,
  Calendar,
  Filter
} from 'lucide-react';
import Sidebar from "../pages/Sidebar.jsx";
import Topbar from "./../components/Topbar.jsx"

// const AgroAdminPanel = () => {
//   const [active, setActive] = useState("Dashboard");

//   const shipments = [
//     { id: "VN-1024", client: "Gourmet Foods Inc.", qty: 120, status: "Dispatched" },
//     { id: "VN-1025", client: "Spice World LLC", qty: 80, status: "In Transit" },
//     { id: "VN-1026", client: "Flavor Labs", qty: 150, status: "Processing" },
//   ];

//   return (
//     <div className="min-h-screen bg-gray-50 px-4 py-6 sm:px-6 md:px-8 space-y-6">
//       {/* Page Heading */}
//       <h1 className="text-xl sm:text-2xl font-bold text-gray-800">Dashboard</h1>

//       {/* Stat Cards */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 ">
//         <Statcard title="Total Products" value="128" />
//         <Statcard title="Pending Orders" value="24" />
//         <Statcard title="Revenue (₹)" value="1.2M" />
//       </div>

//       {/* Shipment Table */}
//       <div className="bg-white p-4 sm:p-6 rounded-lg shadow">
//         <h2 className="text-lg font-semibold text-gray-700 mb-4">Recent Shipments</h2>
//         <Shippmenttable shipments={shipments} />
//       </div>

//       {/* Placeholder for future sections */}
//       {/* Optional: Render section info on mobile */}
//       {active !== "Dashboard" && (
//         <p className="text-center text-gray-500 text-lg">{active} section coming soon.</p>
//       )}
//     </div>
//   );
// };

const AgroAdminPanel = () => {
  const [active, setActive] = useState("Dashboard");
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const shipments = [
    { id: "VN-1024", client: "Gourmet Foods Inc.", qty: 120, status: "Dispatched" },
    { id: "VN-1025", client: "Spice World LLC", qty: 80, status: "In Transit" },
    { id: "VN-1026", client: "Flavor Labs", qty: 150, status: "Processing" },
    { id: "VN-1027", client: "Organic Market", qty: 200, status: "Delivered" },
  ];

  const quickActions = [
    { name: "Add Product", color: "blue" },
    { name: "New Order", color: "green" },
    { name: "Generate Report", color: "purple" },
  ];

  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* <Sidebar 
        active={active} 
        setActive={setActive} 
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
      /> */}
      
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* <Topbar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} /> */}
        
        <main className="flex-1 overflow-x-hidden overflow-y-auto">
          <div className="px-4 py-6 sm:px-6 lg:px-8">
            {active === "Dashboard" ? (
              <div className="space-y-6">
                {/* Page Header */}
                {/* <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
                  <div>
                    <h1 className="text-2xl font-bold text-gray-900">Dashboard</h1>
                    <p className="text-sm text-gray-600 mt-1">Welcome back! Here's what's happening with your agro business.</p>
                  </div>
                  <div className="mt-4 sm:mt-0 flex items-center space-x-3">
                    <button className="flex items-center px-3 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50">
                      <Calendar className="h-4 w-4 mr-2" />
                      Last 30 days
                    </button>
                    <button className="flex items-center px-3 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50">
                      <Filter className="h-4 w-4 mr-2" />
                      Filter
                    </button>
                  </div>
                </div> */}

                {/* Stats Grid */}
                <div className="grid grid-cols-1 sm:grid-cols-2 shadow-md lg:grid-cols-4 gap-6">
                  <StatCard 
                    title="Total Products" 
                    value="128" 
                    icon={Package}
                    trend="up"
                    trendValue="+12%"
                    color="blue"          
                  />
                  <StatCard 
                    title="Pending Orders" 
                    value="24" 
                    icon={ShoppingCart}
                    trend="down"
                    trendValue="-5%"
                    color="orange"
                  />
                  <StatCard 
                    title="Revenue" 
                    value="₹1.2M" 
                    icon={TrendingUp}
                    trend="up"
                    trendValue="+18%"
                    color="green"
                  />
                  <StatCard 
                    title="Active Shipments" 
                    value="15" 
                    icon={Truck}
                    trend="up"
                    trendValue="+3%"
                    color="purple"
                  />
                </div>

                {/* Quick Actions */}
                {/* <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
                  <h2 className="text-lg font-semibold text-gray-900 mb-4">Quick Actions</h2>
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                    {quickActions.map((action, index) => (
                      <button
                        key={index}
                        className={`p-4 rounded-lg border-2 border-dashed border-gray-300 hover:border-blue-500 hover:bg-blue-50 transition-colors text-center group`}
                      >
                        <p className="font-medium text-gray-700 group-hover:text-blue-700">{action.name}</p>
                      </button>
                    ))}
                  </div>
                </div> */}

                {/* Shipment Table */}
                <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
                  <div className="flex items-center justify-between mb-6">
                    <h2 className="text-lg font-semibold text-gray-900">Recent Shipments</h2>
                    <button className="text-blue-600 hover:text-blue-800 text-sm font-medium">
                      View all
                    </button>
                  </div>
                  <ShipmentTable shipments={shipments} />
                </div>
              </div>
            ) : (
              <div className="text-center py-12">
                <div className="max-w-md mx-auto">
                  <Package className="h-12 w-12 text-gray-400 mx-auto mb-4" />
                  <h3 className="text-lg font-medium text-gray-900 mb-2">{active} Section</h3>
                  <p className="text-gray-600">This section is coming soon. We're working hard to bring you this feature.</p>
                </div>
              </div>
            )}
          </div>
        </main>
      </div>
    </div>
  );
};

export default AgroAdminPanel;
